import Select from "react-select";
import AssignmentModeToggle from "./AssignmentModeToggle";
import AssignmentTextField from "./AssignmentTextField";
import AssignmentDetailCard from "./AssignmentDetailCard";
import { assignmentSelectComponents, assignmentSelectStyles } from "./assignmentSelectStyles";
import { CUSTOM, FLEET, UPGRADE, isOfBookedVehicleType, vehicleOptionsForMode } from "./assignmentUtils";

const MODES = [
    { value: FLEET, label: "From our fleet" },
    { value: UPGRADE, label: "Free upgrade" },
    { value: CUSTOM, label: "Other" },
];

/**
 * The vehicle half of one slot, in three modes: our own fleet held to the class
 * that was booked, a free upgrade that opens the list to every class we own, and
 * free text for a partner company vehicle we hold no record of.
 */
const VehicleAssignmentField = ({ index, assignment, options, bookedVehicleTypeId, menuPortalTarget, onPatch }) => {
    const mode = assignment.vehicleAssignmentType;
    const isCustom = mode === CUSTOM;
    // Resolved against the whole fleet, not the mode's list, so whatever is
    // saved on the booking always shows even if the mode would not offer it.
    const selectedOption = options.find((option) => option.value === assignment.vehicle) || null;

    const handleModeChange = (nextMode) => {
        const patch = { vehicleAssignmentType: nextMode };

        // Returning to the booked class drops a vehicle of any other class, so an
        // upgrade can never be submitted as though it were what was booked.
        if (nextMode === FLEET && !isOfBookedVehicleType(assignment.vehicle, options, bookedVehicleTypeId)) {
            patch.vehicle = "";
        }
        onPatch(patch);
    };

    return (
        <div className="tw:grid tw:grid-cols-1 tw:gap-4 tw:md:grid-cols-[220px_1fr] tw:md:items-start">
            <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[700] tw:text-[#4E4E4E] tw:md:pt-3">
                Vehicle
            </div>
            <div className="tw:flex tw:flex-col tw:gap-3">
                <AssignmentModeToggle
                    label={`Vehicle source for vehicle #${index + 1}`}
                    value={mode}
                    options={MODES}
                    onChange={handleModeChange}
                />

                {isCustom ? (
                    <div className="tw:grid tw:grid-cols-1 tw:gap-3 tw:md:grid-cols-2">
                        <AssignmentTextField
                            label="Vehicle name / model"
                            placeholder="e.g. Lexus LM 500h (partner company)"
                            value={assignment.customVehicleName}
                            onChange={(value) => onPatch({ customVehicleName: value })}
                        />
                        <AssignmentTextField
                            label="Registration number (optional)"
                            placeholder="e.g. 品川 300 さ ･･･8"
                            value={assignment.customVehicleRegistration}
                            onChange={(value) => onPatch({ customVehicleRegistration: value })}
                        />
                    </div>
                ) : (
                    <>
                        <Select
                            placeholder="Select"
                            classNamePrefix={`react-select-assignment-vehicle-${index}`}
                            styles={assignmentSelectStyles}
                            autoComplete="off"
                            menuPortalTarget={menuPortalTarget}
                            menuPosition="fixed"
                            value={selectedOption}
                            options={vehicleOptionsForMode(options, mode, bookedVehicleTypeId)}
                            noOptionsMessage={() =>
                                mode === FLEET
                                    ? "No vehicle of the booked type is available — try a free upgrade"
                                    : "No vehicle available"
                            }
                            onChange={(option) => onPatch({ vehicle: option?.value || "" })}
                            components={assignmentSelectComponents}
                        />

                        {selectedOption ? (
                            <AssignmentDetailCard
                                rows={[
                                    { label: "Vehicle Type", value: selectedOption.vehicleType },
                                    { label: "Registration Number", value: selectedOption.registrationNumber },
                                ]}
                            />
                        ) : null}
                    </>
                )}
            </div>
        </div>
    );
};

export default VehicleAssignmentField;
